import { useState } from 'preact/hooks';
import { Pill } from '@/components/Pill';
import { recipes } from '@/recipes/_generated';
import { ALL_TAGS, matchesTagSelection, type TagCategory, tagLabel } from '@/tags';

type Selection = Partial<Record<TagCategory, Set<string>>>;

export function Browse() {
  const [selected, setSelected] = useState<Selection>({});
  const filtered = recipes.filter(({ recipe }) => matchesTagSelection(recipe.tags, selected));

  return (
    <>
      <div class="browse-subheader">
        <div class="browse-subheader__label">All Recipes</div>
        <div class="tag-row">
          {ALL_TAGS.map(({ category, value }) => (
            <Pill
              key={`${category}:${value}`}
              label={tagLabel(value)}
              selected={selected[category]?.has(value) ?? false}
              onClick={() =>
                setSelected((prev) => {
                  const next = new Set(prev[category] ?? []);
                  if (next.has(value)) next.delete(value);
                  else next.add(value);
                  return { ...prev, [category]: next };
                })
              }
            />
          ))}
        </div>
      </div>
      {filtered.length === 0 ? (
        <p class="empty">No recipes match</p>
      ) : (
        <ul class="recipe-list">
          {filtered.map(({ slug, recipe }) => (
            <li key={slug} class="recipe-list__item">
              <a href={`/r/${slug}`}>
                {recipe.title}
                {recipe.tags?.type ? (
                  <span class="amount"> {tagLabel(recipe.tags.type)}</span>
                ) : null}
              </a>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
